import { render, staticRenderFns } from "./message-composer.vue?vue&type=template&id=1b255f9a&scoped=true"
import script from "./message-composer.vue?vue&type=script&lang=js"
export * from "./message-composer.vue?vue&type=script&lang=js"
import style0 from "./message-composer.vue?vue&type=style&index=0&id=1b255f9a&prod&lang=scss&scoped=true"
import style1 from "./message-composer.vue?vue&type=style&index=1&id=1b255f9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b255f9a",
  null
  
)

export default component.exports